import React from 'react';
import { Grid, Stack } from '@mantine/core';
import FavouriteLeagues from './components/FavouriteLeagues';
import FilteredFixtures from './components/FilteredFixtures';
import StandingsPanel from './components/StandingsPanel';
import LeagueSelect from '../../components/inputs/LeagueSelect';
import Layout from '../../components/layout/Layout';
import { Divider } from 'antd';


const TOP_LEAGUES = [39, 140, 78, 61, 135, 2, 3, 94, 88, 203, 179, 143];
const CURRENT_SEASON = new Date().getMonth() > 5 ? new Date().getFullYear() : new Date().getFullYear() - 1;


export default function Fixtures({ rapidKey = process.env.REACT_APP_RAPIDAPI_KEY }) {
    const [leagueId, setLeagueId] = React.useState(String(TOP_LEAGUES[0]));
    const [favorites, setFavorites] = React.useState([39, 140, 78]);

    return (
        <Layout headerStyle={1} footerStyle={1} breadcrumbTitle="title">
            <div className="w-100" style={{ backgroundColor: '#f5f5f5' }}>
                <div
                    className="container"
                    style={{ maxWidth: '1400px', margin: '0 auto', paddingTop: 20, paddingBottom: 40, textAlign: 'left' }}
                >
                    <h5 className="section-title mb-0">Fixtures, Results & Standings</h5>
                    <p className="section-subtitle mb-3">
                        Browse upcoming and past fixtures, league standings, team lineups, and recent transfers across top football
                        competitions worldwide.
                    </p>
                    <Divider className="w-100" />

                    <Grid gutter="md">
                        <Grid.Col span={{ lg: 3 }} visibleFrom="lg">
                            <Stack gap="md">
                                <FavouriteLeagues
                                    rapidKey={rapidKey}
                                    favorites={favorites}
                                    setFavorites={setFavorites}
                                    leagueIds={TOP_LEAGUES}
                                />
                                {/* <CoverageLeagues rapidKey={rapidKey} onPick={(id) => setLeagueId(String(id))} /> */}
                            </Stack>
                        </Grid.Col>

                        <Grid.Col span={{ base: 12, md: 9, lg: 6 }}>
                            <FilteredFixtures rapidKey={rapidKey} leagueId={leagueId} season={CURRENT_SEASON} />
                        </Grid.Col>

                        <Grid.Col span={{ base: 12, md: 3, lg: 3 }}>
                            <LeagueSelect
                                rapidKey={rapidKey}
                                leagueIds={TOP_LEAGUES}
                                value={leagueId}
                                onChange={setLeagueId}
                                label="Choose competition"
                            />
                            <Stack gap="md">
                                <StandingsPanel rapidKey={rapidKey} leagueId={leagueId} season={CURRENT_SEASON} />
                                {/* <TransfersPanel rapidKey={rapidKey} leagueId={leagueId} season={CURRENT_SEASON} /> */}
                                {/* <TeamPanel rapidKey={rapidKey} leagueId={leagueId} season={CURRENT_SEASON} /> */}
                            </Stack>
                        </Grid.Col>
                    </Grid>
                </div>
            </div>
        </Layout>
    );
}
